import { Pipe, PipeTransform } from '@angular/core';

import { CustomTranslationsService } from '../translations';
import { AggregatedStatus } from '../../../projects/client';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateAggregatedStatus',
  standalone: true,
})
export class TranslateAggregatedStatusPipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}
  transform(value: AggregatedStatus): string {
    if (value && this.customTranslationsService.AGGREGATED_STATUS[value]) {
      return this.translateService.instant(this.customTranslationsService.AGGREGATED_STATUS[value]);
    }

    return value;
  }
}
